import { render, staticRenderFns } from "./RecordItem.vue?vue&type=template&id=211953f8&scoped=true&"
import script from "./RecordItem.vue?vue&type=script&lang=js&"
export * from "./RecordItem.vue?vue&type=script&lang=js&"
import style0 from "./RecordItem.vue?vue&type=style&index=0&id=211953f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211953f8",
  null
  
)

export default component.exports